import React from "react";
import { withStyles, makeStyles } from "@material-ui/core";
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { Form } from "react-bootstrap";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    // minWidth: 700,
  },
}));

export default function MiteraMentorUpdateTable(props) {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {/* <StyledTableCell align="center">Attended</StyledTableCell> */}
            <StyledTableCell align="center">Attendent</StyledTableCell>
            <StyledTableCell align="center">Mentor First Name</StyledTableCell>
            <StyledTableCell align="center">Mentor Last Name</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tableData &&
            props.tableData.map((row, i) => (
              <StyledTableRow key={i}>
                <StyledTableCell align="center">
                  <Form.Check
                    checked={
                      props.attended && props.attended.includes(row.mentorID)
                    }
                    onChange={(e) => props.onChangeAttendend(row.mentorID, i)}
                  />
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.firstName ? row.firstName : "-"}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.lastName ? row.lastName : "-"}
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
